import * as React from 'react';
import CardSection from '../../common/CardSection';
import Form from 'src/components/controls/forms/Form';
import Office from '../../../models/Office';
import Textbox from 'src/components/controls/forms/redesign/FormTextbox';
import Select from 'src/components/controls/forms/redesign/FormFilterSelect';
// import { FormErrors } from 'src/util/FormErrors';
import FormRow from '../../controls/forms/FormRow';
import { SelectItem } from 'src/models/common/SelectItem';
import State from '../../../models/State';
import { ODataOptions } from 'src/util/ODataBuilder';
import PagedResultSet from 'src/models/common/PagedResultSet';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router';
import actions from 'src/actions';
import { IRootState } from 'src/reducers';
// import Address from 'src/models/Address';
import { AnyObject } from 'final-form';
// import { AnyObject } from 'final-form';

interface IAdminCreateOfficePageStoreProps {
    states: PagedResultSet<State>;
}

interface IAdminCreateOfficePageDispatchProps {
    navigate: (path: string) => void;
    createOffice: (office: Office) => void;
    getStates: (options: ODataOptions) => void;
}

type IAdminCreateOfficePageProps = IAdminCreateOfficePageStoreProps & IAdminCreateOfficePageDispatchProps;

class AdminCreateOfficePage extends React.Component<IAdminCreateOfficePageProps> {
    constructor(props: IAdminCreateOfficePageProps) {
        super(props);
    }

    validate = (office: Office) => {
        // TODO: Add ability to map Deep objects in FormErrors. Use AnyObject for now
        const errors: AnyObject = {};
        errors.address = {};

        errors.name = 'Name required';
        errors.address.addressLine1 = 'Address Line 1 required';
        errors.address.city = 'City required';
        errors.address.state = 'State required';
        errors.address.zipCode = 'Zipcode required';
        if (office.name !== undefined) {
            errors.name = undefined;
        }
        if (office.address) {
            if (office.address.addressLine1) {
                errors.address.addressLine1 = undefined;
            }
            if (office.address.city) {
                errors.address.city = undefined;
            }
            if (office.address.state) {
                errors.address.state = undefined;
            }
            if (office.address.zipCode) {
                errors.address.zipCode = undefined;
            }
            if (office.address.addressLine1 && office.address.city && office.address.state && office.address.zipCode) {
                errors.address = undefined;
            }
        }

        return errors;
    };

    componentDidMount() {
        this.props.getStates(new ODataOptions().addPaging(1, 100));
    }

    public render() {
        const selectStates = this.props.states?.items?.map((state: State) => new SelectItem(state.id, state.name));

        return (
            <CardSection title="Create Office">
                <Form onSubmit={this.props.createOffice} validate={this.validate}>
                    <Textbox label="Name" name="name" />
                    <Textbox label="Address Line 1" name="address.addressLine1" />
                    <Textbox label="Address Line 2" name="address.addressLine2" />
                    <FormRow>
                        <Textbox label="City" name="address.city" />
                        <Select label="State" name="address.state.id" items={selectStates} />
                        <Textbox label="Zipcode" name="address.zipCode" />
                    </FormRow>

                    <button className="bp3-button pt-intent-primary" type="submit">
                        Submit
                    </button>
                </Form>
            </CardSection>
        );
    }
}

const mapStateToProps = (state: IRootState): IAdminCreateOfficePageStoreProps => {
    return {
        states: state.state.states,
    };
};

const mapDispatchToProps: IAdminCreateOfficePageDispatchProps = {
    navigate: (path: string) => replace(path),
    createOffice: (office: Office) => actions.office.createOffice(office),
    getStates: (options: ODataOptions) => actions.state.getStates(options),
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminCreateOfficePage);



// WEBPACK FOOTER //
// ./src/components/admin/sections/AdminCreateOfficePage.tsx